module.exports = __webpack_public_path__ + "static/media/eight-on.a38132ac.png";